import { useState, useEffect } from 'react'
import { getCurrentUser } from '../../lib/supabase'
import { hasAdminAccess } from '../../lib/roles'

interface AdminCheckProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export default function AdminCheck({ children, fallback }: AdminCheckProps) {
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    checkAdminStatus()
  }, [])

  const checkAdminStatus = async () => {
    try {
      const { data: { user } } = await getCurrentUser()
      if (user && hasAdminAccess(user)) {
        setIsAdmin(true)
      }
    } catch (error) {
      console.error('Admin check error:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return null // Don't show anything while loading
  }

  if (isAdmin) {
    return <>{children}</>
  }

  return <>{fallback || null}</>
}